import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";
import LogoRotation from '../Assests/raw/Logo rotation.json';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';
import img1 from '../Assests/corporateAssert/CW-1.png';
import img2 from '../Assests/corporateAssert/CW-2.png';
import img3 from '../Assests/corporateAssert/CW-3.png';
import img4 from '../Assests/corporateAssert/CW-4.png';
import img5 from '../Assests/corporateAssert/CW-5.png';

export default function CorporateWellness() {
  const images = [img1, img2, img3, img4, img5];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      // Start fade-out effect for the image only
      setFade(false);
      // After transition duration (e.g., 500ms), change the image and fade it back in
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        setFade(true);
      }, 500);
    }, 3000); // change interval as needed
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="corporateWellness">
      <div className="background">
        <div className="corporate-container">
          <div className="text-section">
            <h1 className="title">Corporate Wellness</h1>
            <h2 className="subtitle">Rejuvenate Your Workforce with Ayurveda 3.0</h2>
            <p className="description">
              We are a first-of-its-kind Ayurveda company, blending ancient wisdom with modern science for powerful holistic solutions.
            </p>
            <div className="cta">
              <PhoneInTalkOutlinedIcon style={{ color: "#fdfdfd" }} />
              <a href="tel:+919280086997" className="ctaButton">
                <p>Call to learn more</p>
              </a>
            </div>
          </div>
          <div className="image-section">
            {/* Apply fade only to the main image */}
            <img
              src={images[currentIndex]}
              className={`mainImage ${fade ? "fade-in" : "fade-out"}`}
              alt="Wellness Program"
            />
            {/* Lottie remains unchanged */}
            {/* <div className="lottie-overlay">
              <Lottie animationData={LogoRotation} loop={true} />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
